<template>
  <div class="test-kit">
    <div class="test-kit-time">
      <div>{{ test.created | date("DD-MM-YYYY") }}</div>
    </div>
    <div class="test-kit-details">
      <div class="test-kit-details-name">
        <span>{{ test.kit.name }}</span>
      </div>
      <div class="test-kit-details-result">
        <div
          v-for="(marker, index) in test.kit.markers"
          :key="'marker-' + index"
          class="single-marker"
        >
          <div class="single-marker-meta">
            <div
              class="single-marker-value-title"
              :style="{
                color: benchmarkTitleValue(marker)
                  ? benchmarkTitleValue(marker).color
                  : 'currentColor'
              }"
            >
              {{
                benchmarkTitleValue(marker)
                  ? benchmarkTitleValue(marker).title
                  : marker.title
              }}
            </div>
            <div class="single-marker-title">
              {{ marker.title }}
            </div>

            <div class="single-marker-value">
              <span>{{ marker.value }}</span> {{ marker.unit }}
            </div>
          </div>
          <div class="single-marker-visual">
            <MarkerRange2 :marker="marker" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkerRange from "./MarkerRange";
import MarkerRange2 from "./MarkerRange2";

export default {
  props: {
    test: {
      type: Object,
      required: true
    }
  },
  components: {
    MarkerRange,
    MarkerRange2
  },
  methods: {
    benchmark(id) {
      return this.$store.getters["TestsStore/benchmarkSingle"](id);
    },
    benchmarkTitleValue(marker) {
      const benchmark = this.benchmark(marker.id);
      if (!benchmark) return;
      var currentRange = null;
      benchmark.range.forEach(range => {
        if (parseInt(marker.value) < parseInt(range.value) && !currentRange)
          currentRange = range;
      });
      return currentRange ? currentRange : "missing";
    }
  },
  computed: {}
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";

.test-kit {
  display: flex;
  flex-direction: row;
  position: relative;
  &:before {
    content: "";
    width: @h2;
    height: @h2;
    position: absolute;
    left: 0;
    top: @h2;
    border-radius: 50%;
    z-index: 2;
    box-shadow: 0 0 0 2px #aaa;
  }
  &:after {
    content: "";
    width: 2px;
    position: absolute;
    background-color: #aaa;
    left: @h1 - 1px;
    top: @h4;
    bottom: 0;
    z-index: 1;
  }

  .test-kit-time {
    flex: 0 240px;
    padding: @h2 @h1 @h1 @h4;

    > div {
      &:first-child {
        color: #888;
      }
    }
  }
  .test-kit-details {
    flex: 1;
    background-color: #fff;
    // box-shadow: 0 3px 10px rgba(0, 0, 0, 0.02), 0 3px 30px rgba(0, 0, 0, 0.05);

    .test-kit-details-name {
      padding: @h3 @h1 @h1 @h1;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      font-weight: 500;
      border-bottom: 1px solid #eee;
      font-size: 2em;
      color: #444;
      span {
        margin-left: @h1;
      }
    }
    .test-kit-details-result {
      .single-marker {
        padding: @h2;
        display: flex;
        border-bottom: 1px solid #eee;
        flex-direction: row;
        .single-marker-meta {
          flex: 0 200px;
          line-height: 1.4;
          margin-top: -@hh;
          div:first-child {
            // font-weight: bold;
          }
          .single-marker-value-title {
            text-transform: uppercase;
            font-weight: 500;
            font-size: 0.8em;
          }
          .single-marker-title {
            font-weight: 500;
            font-size: 1.2em;
            color: #444;
          }
          .single-marker-value {
            span {
              font-weight: 500;
              font-size: 1.2em;
              color: #444;
            }
            color: #888;
          }
        }
        .single-marker-visual {
          flex: 1;
        }
      }
    }
  }

  & + .test-kit {
    margin-top: @h1;
  }
}
</style>
